import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Flex, spaces, TabButtonGroup } from '@electricjs/arc';

import { Store, StorefrontProductTypeGroup } from '@/types/storefront';
import { SelectionParamKeys } from '@/types/queryParamKeys';

import { CatalogStore, CatalogStoreProps } from '../Catalog/CatalogStore';
import { AssetStore, AssetStoreProps } from '../Asset/AssetStore';

export type StoreSectionProps = Omit<
  CatalogStoreProps & AssetStoreProps,
  'selectedProductTypeGroup' | 'onProductTypeGroupSelect'
>;

export const StoreSection = ({
  laptopRecommendationUrl,
}: StoreSectionProps) => {
  const { t } = useTranslation('storefront');
  const [queryParams] = useSearchParams();
  const assetId = queryParams.get(SelectionParamKeys.AssetId);
  const [selectedStore, setSelectedStore] = useState<Store>(Store.Catalog);

  useEffect(() => {
    if (assetId) {
      setSelectedStore(Store.Asset);
    }
  }, [assetId]);

  const [selectedProductTypeGroup, setSelectedProductTypeGroup] =
    useState<StorefrontProductTypeGroup>(StorefrontProductTypeGroup.Laptops);

  const handleProductTypeGroupSelection = (
    group: StorefrontProductTypeGroup
  ) => {
    setSelectedProductTypeGroup(group);
  };

  return (
    <Flex vertical rowGap={spaces.space_xl}>
      {/* Store Selector */}
      <TabButtonGroup
        tabs={[
          { value: Store.Catalog, label: t('sections.store.catalogTab') },
          { value: Store.Asset, label: t('sections.store.assetTab') },
        ]}
        activeTabValue={selectedStore}
        onTabChange={tabValue => setSelectedStore(tabValue as Store)}
      />

      {/* Stores (Catalog, Assets) */}
      {selectedStore === Store.Catalog && (
        <CatalogStore
          selectedProductTypeGroup={selectedProductTypeGroup}
          onProductTypeGroupSelect={handleProductTypeGroupSelection}
          laptopRecommendationUrl={laptopRecommendationUrl}
        />
      )}
      {selectedStore === Store.Asset && (
        <AssetStore
          selectedProductTypeGroup={selectedProductTypeGroup}
          onProductTypeGroupSelect={handleProductTypeGroupSelection}
          laptopRecommendationUrl={laptopRecommendationUrl}
        />
      )}
    </Flex>
  );
};
